export const getLinkPropsByArticleSlug = (slug: string) => ({
  href: '/articles/[articleSlug]',
  as: `/articles/${slug}`,
})
